"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyActionCallBack = void 0;
const base_1 = require("./base");
const enums_1 = require("../../enums");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
exports.JourneyActionCallBack = (0, base_1.journeyAction)({
    action: enums_1.JourneyActionEnum.CallBack,
    channels: [enums_1.ChannelEnum.Voice],
    direction: enums_1.JourneyNodeDirectionEnum.InputOutput,
    settings_schema: (0, base_1.settingsValidationSchema)({
        queue_id: {
            type: "number",
            required: true,
        },
    }),
    getPorts: (node) => {
        return Object.assign(Object.assign({}, base_1.journeyDefaultInputPort), { [constants_1.JOURNEY_ACTION_CALL_BACK_SUCCESS_OUTPUT]: (0, utils_1.journeyNodePortAddDefault)({
                id: constants_1.JOURNEY_ACTION_CALL_BACK_SUCCESS_OUTPUT,
                type: enums_1.JourneyPortDirectionEnum.Output,
                removable: false,
                required: false,
                index: 0,
                title: "NEXT",
                color: null,
            }) });
    },
});
